<template>
  <section class="py-0" :class="classes" v-if="ready" id="checkout-pricing-overview">
    <div class="row">
      <div class="col-12 d-none d-lg-block">
        <p class="mb-0 d-flex justify-content-between">
            <strong>
                {{ $t('vue.checkout.shared.subscriptionCosts.monthlySubscriptionCost') }} {{ vehicle.brand.title }} {{ vehicle.model.title }}</strong>
        </p>
      </div>
      <div class="col-12 d-block d-lg-none">
        <p class="mb-0">
            <strong>{{ $t('vue.checkout.shared.subscriptionCosts.monthlySubscriptionCost') }}
            {{ vehicle.brand.title }} {{ vehicle.model.title }}</strong>
        </p>
      </div>
      <div class="col-12 overview-hr mb-2 mt-2">
      </div>
      <div class="col-10 text-success"><strong>
          <span class="condensed">
              {{ $t('vue.checkout.shared.subscriptionCosts.includedInCost') }}
          </span>
      </strong>
      </div>
      <div class="col-10"><i class="fal fa-check text-success"></i>
          <span class="condensed">{{ $t('vue.checkout.shared.subscriptionCosts.usageOfVehicle') }}</span>
      </div>
      <div class="col-2 d-flex justify-content-end text-success">
        <span class="condensed">{{ priceWithCurrency (0) }}</span>
      </div>
      <div class="col-10"><i class="fal fa-check text-success"></i>
          <span class="condensed">
              {{ $t('vue.checkout.shared.subscriptionCosts.seasonWheels') }}
          </span>
      </div>
      <div class="col-2 d-flex justify-content-end text-success">
        <span class="condensed">{{ priceWithCurrency (0) }}</span>
      </div>
      <div class="col-10"><i class="fal fa-check text-success"></i>
          <span class="condensed">
              {{ $t('vue.checkout.shared.subscriptionCosts.motorwayVignette') }}
          </span>
      </div>
      <div class="col-2 d-flex justify-content-end text-success">
        <span class="condensed">{{ priceWithCurrency (0) }}</span>
      </div>
      <div class="col-10"><i class="fal fa-check text-success"></i>
          <span class="condensed">
              {{ $t('vue.checkout.shared.subscriptionCosts.extraCosts') }}
          </span>
      </div>
      <div class="col-2 d-flex justify-content-end text-success">
        <span class="condensed">{{ priceWithCurrency (0) }}</span>
      </div>
      <div class="col-10"><i class="fal fa-check text-success"></i>
          <span class="condensed">{{ $t('vue.checkout.shared.subscriptionCosts.insurance') }} </span>
      </div>
      <div class="col-2 d-flex justify-content-end text-success">
        <span class="condensed">{{ priceWithCurrency (0) }}</span>
      </div>
      <div class="col-10"><i class="fal fa-check text-success"></i>
          <span class="condensed">
              {{ $t('vue.checkout.shared.subscriptionCosts.repair') }}
          </span>
      </div>
      <div class="col-2 d-flex justify-content-end text-success">
        <span class="condensed">{{ priceWithCurrency (0) }}</span>
      </div>
    </div>
    <div class="col-12 overview-hr mb-2 mt-2">
    </div>
    <div class="row">
      <div class="col-12 d-flex justify-content-end" id="price-complete">
        <strong>
            <span class="condensed">
                {{ $t('vue.checkout.shared.subscriptionCosts.costWithVAT') }}
                  {{ priceWithCurrency (priceWithTax) }}
                </span>
        </strong>
      </div>
      <div class="col-12 d-flex justify-content-end text-success">
        <strong><i class="far fa-check"></i>
            <span class="condensed">
                {{ $t('vue.checkout.shared.subscriptionCosts.noEntryFee') }}
            </span>
        </strong>
      </div>
    </div>
  </section>
</template>

<script>
// ToDo: Nur Preis und Fahrzeug-Titel als Props.
export default {
  name: "SubscriptionCosts",
  props: {
    currency: {
      type: String,
      default: "€"
    },
    vehicle: {
      type: Object,
      required: true
    },
    subscription: {
      type: Object,
      required: true
    },
    classes: {
      type: String,
      required: false,
      default: "col-12 col-md-12"
    }
  },
  data () {
    return {
      ready: false
    }
  },
  methods: {
    getPriceFromSubscription () {
      return parseFloat (this.subscription.price);
    },
    priceWithCurrency (price) {
      const isInt = price % 1 === 0;
      if (isInt) return `CHF\xa0${price}.–`
      else return new Intl.NumberFormat ('de-CH', {
        style: 'currency',
        currency: "CHF"
      }).format (price)
    }
  },
  computed: {
    priceWithoutTax () {
      let price = this.getPriceFromSubscription ();
      let priceWithoutTax = (price / 119) * 100;
      return priceWithoutTax
    },
    tax () {
      let price = this.getPriceFromSubscription ();
      let tax = (price / 119) * 19;
      return tax
    },
    priceWithTax () {
      let price = this.getPriceFromSubscription ();
      return price
    }
  },
  mounted () {
    this.ready = true;
  }
}
</script>

<style scoped lang="scss">

</style>
